import { useModel as _useModel, mergeModels as _mergeModels } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "conflict-resolution" }
const _hoisted_2 = { class: "mb-4" }
const _hoisted_3 = { class: "d-flex align-items-center mb-3" }
const _hoisted_4 = { class: "mb-1 fw-bold" }
const _hoisted_5 = {
  key: 0,
  class: "bg-light rounded p-3 mb-4",
  style: {"max-height":"200px","overflow-y":"auto"}
}
const _hoisted_6 = { class: "list-unstyled mb-0" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = { class: "resolution-options" }
const _hoisted_10 = {
  key: 0,
  class: "mb-3 fw-bold"
}
const _hoisted_11 = { class: "row g-3" }
const _hoisted_12 = {
  key: 0,
  class: "col-12"
}
const _hoisted_13 = { class: "card-body" }
const _hoisted_14 = { class: "form-check" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = { class: "card-body" }
const _hoisted_17 = { class: "form-check" }
const _hoisted_18 = {
  class: "form-check-label w-100",
  for: "resolution-change-config"
}
const _hoisted_19 = { class: "text-muted mb-0" }

import { computed } from "vue";
import dayjs from "dayjs";
import { useDateUtils } from "../../composables/useDateUtils.js";


export default {
  __name: 'BookingConflictResolutionPanel',
  props: /*@__PURE__*/_mergeModels({
	conflictData: { type: Object, default: () => ({ hasConflict: false }) },
}, {
    "selectedResolution": {
	type: String,
	default: "cancellations",
},
    "selectedResolutionModifiers": {},
  }),
  emits: ["update:selectedResolution"],
  setup(__props) {

const props = __props;

const selectedResolution = _useModel(__props, "selectedResolution");

const { formatDateForDisplay } = useDateUtils();

// Check if this is a series booking based on conflict data
const isSeriesBooking = computed(() => {
	if (!props.conflictData?.originalData) return false;

	// Check for series indicators
	const data = props.conflictData.originalData;
	return !!(
		data.rrulePattern ||
		data.pattern ||
		data.seriesId ||
		data.bookingType === "series"
	);
});

// Check if we have any conflicting or closed dates to display
const hasConflictingOrClosedDates = computed(() => {
	const conflictingDates = props.conflictData?.conflictingDates || [];
	const closedDates = props.conflictData?.closedDates || [];
	return conflictingDates.length > 0 || closedDates.length > 0;
});

// Check conflict types
const hasBookingConflicts = computed(() => {
	return (
		props.conflictData?.hasBookingConflicts ||
		(props.conflictData?.conflictingDates || []).length > 0
	);
});

const hasClosedHours = computed(() => {
	return (
		props.conflictData?.hasClosedHours ||
		(props.conflictData?.closedDates || []).length > 0
	);
});

const conflictTitle = computed(() => {
	const isSeries = isSeriesBooking.value;
	const hasBooking = hasBookingConflicts.value;
	const hasClosed = hasClosedHours.value;

	if (hasBooking && hasClosed) {
		return isSeries
			? "Die folgenden Termine der Serie kollidieren mit bestehenden Buchungen oder " +
					"sind außerhalb der Öffnungszeiten:"
			: "Dieser Termin kollidiert mit einer bestehenden Buchung oder " +
					"ist außerhalb der Öffnungszeiten:";
	}
	if (hasBooking) {
		return isSeries
			? "Die folgenden Termine der Serie kollidieren mit bestehenden Buchungen:"
			: "Dieser Termin kollidiert mit einer bestehenden Buchung:";
	}
	if (hasClosed) {
		return isSeries
			? "Die folgenden Termine der Serie sind außerhalb der Öffnungszeiten:"
			: "Dieser Termin ist außerhalb der Öffnungszeiten:";
	}

	return "Es wurden Konflikte erkannt:";
});

// Format conflicting dates for display
function formatConflictDate(dateString) {
	const date = dayjs(dateString);
	if (!date.isValid()) {
		console.warn("Failed to format date:", dateString);
		return dateString;
	}

	return formatDateForDisplay(date.toDate());
}

return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-warning me-2" }, [
          _createElementVNode("i", { class: "fas fa-exclamation-triangle fa-lg" })
        ], -1 /* CACHED */)),
        _createElementVNode("div", null, [
          _createElementVNode("p", _hoisted_4, _toDisplayString(conflictTitle.value), 1 /* TEXT */)
        ])
      ]),
      _createCommentVNode(" Conflicting dates list "),
      (hasConflictingOrClosedDates.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("ul", _hoisted_6, [
              _createCommentVNode(" Booking conflicts "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.conflictData.conflictingDates, (date) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `conflict-${date}`,
                  class: "d-flex align-items-center mb-2"
                }, [
                  _cache[4] || (_cache[4] = _createElementVNode("i", { class: "fas fa-times text-danger me-2" }, null, -1 /* CACHED */)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_7, _toDisplayString(formatConflictDate(date)), 1 /* TEXT */),
                    _cache[3] || (_cache[3] = _createElementVNode("small", { class: "text-muted" }, " Kollidiert mit vorhandener Buchung ", -1 /* CACHED */))
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */)),
              _createCommentVNode(" Opening hours conflicts "),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.conflictData.closedDates, (date) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: `closed-${date}`,
                  class: "d-flex align-items-center mb-2"
                }, [
                  _cache[6] || (_cache[6] = _createElementVNode("i", { class: "fas fa-clock text-warning me-2" }, null, -1 /* CACHED */)),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(formatConflictDate(date)), 1 /* TEXT */),
                    _cache[5] || (_cache[5] = _createElementVNode("small", { class: "text-muted" }, " Außerhalb der Öffnungszeiten ", -1 /* CACHED */))
                  ])
                ]))
              }), 128 /* KEYED_FRAGMENT */))
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createCommentVNode(" Resolution options "),
      _createElementVNode("div", _hoisted_9, [
        (isSeriesBooking.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, " Wie möchten Sie diese Konflikte lösen? "))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_11, [
          _createCommentVNode(" Option 1: Add as cancellations (only for series bookings) "),
          (isSeriesBooking.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createElementVNode("div", {
                  class: _normalizeClass(["card border-primary", {
                'bg-light': selectedResolution.value === 'cancellations',
              }])
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("div", _hoisted_14, [
                      _withDirectives(_createElementVNode("input", {
                        id: "resolution-cancellations",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((selectedResolution).value = $event)),
                        class: "form-check-input",
                        type: "radio",
                        value: "cancellations"
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelRadio, selectedResolution.value]
                      ]),
                      _cache[7] || (_cache[7] = _createElementVNode("label", {
                        class: "form-check-label w-100",
                        for: "resolution-cancellations"
                      }, [
                        _createElementVNode("h6", { class: "d-flex align-items-center mb-2" }, [
                          _createElementVNode("i", { class: "fas fa-calendar-times text-warning me-2" }),
                          _createTextVNode(" Als Ausfalltermine markieren ")
                        ]),
                        _createElementVNode("p", { class: "text-muted mb-0" }, " Die problematischen Termine werden automatisch als Ausfalltermine zur Serie hinzugefügt. Die Serie wird ohne diese Termine erstellt. ")
                      ], -1 /* CACHED */))
                    ])
                  ])
                ], 2 /* CLASS */)
              ]))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" Option 2: Change configuration "),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", {
              class: _normalizeClass(["card border-info", {
                'bg-light': selectedResolution.value === 'change-config',
              }])
            }, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    id: "resolution-change-config",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((selectedResolution).value = $event)),
                    class: "form-check-input",
                    type: "radio",
                    value: "change-config"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelRadio, selectedResolution.value]
                  ]),
                  _createElementVNode("label", _hoisted_18, [
                    _cache[8] || (_cache[8] = _createElementVNode("h6", { class: "d-flex align-items-center mb-2" }, [
                      _createElementVNode("i", { class: "fas fa-cog text-info me-2" }),
                      _createTextVNode(" Konfiguration ändern ")
                    ], -1 /* CACHED */)),
                    _createElementVNode("p", _hoisted_19, _toDisplayString(isSeriesBooking.value
                          ? `Gehen Sie zurück zur Buchung und passen Sie Uhrzeit, 
                              Wiederholungsmuster oder Ausfalltermine an, um Konflikte 
                              und Öffnungszeiten-Probleme zu vermeiden.`
                          : `Gehen Sie zurück zur Buchung und passen Sie Uhrzeit oder Datum an, 
                              um Konflikte und Öffnungszeiten-Probleme zu vermeiden.`), 1 /* TEXT */)
                  ])
                ])
              ])
            ], 2 /* CLASS */)
          ])
        ])
      ])
    ])
  ]))
}
}

}